import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
const aligns = {
    center: 'items-center',
    start: 'items-start',
};
export const ContentWithAvatar = (props) => {
    const { align = 'center', avatarComponent, children, className = '' } = props;
    return (_jsxs("div", Object.assign({ className: clsx('flex flex-nowrap gap-x-8', aligns[align], className) }, { children: [_jsx("div", Object.assign({ className: 'grow-0 shrink-0' }, { children: avatarComponent })), _jsx("div", Object.assign({ className: 'grow' }, { children: children }))] })));
};
